var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNatur(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "456px",
    height: "74px",
    viewBox: "0 0 456 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 20") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.83010076,1.0141862 L14.9687606,27.7585528 C15.1281708,28.4530569 14.6618281,29.1382257 13.927155,29.28892 C13.8323209,29.3083721 13.7355582,29.3181818 13.6385173,29.3181818 L1.36119761,29.3181818 C0.60942893,29.3181818 0,28.742074 0,28.0314089 C0,27.9396739 0.0103771018,27.8482018 0.0309543187,27.7585528 L6.16961417,1.0141862 C6.32902437,0.319682044 7.05382207,-0.121162948 7.78849516,0.0295313499 C8.30979913,0.136459911 8.71698763,0.521385002 8.83010076,1.0141862 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06408061,0.778328943 L11.9750085,21.3030754 C12.1025366,21.836067 11.7294625,22.3618941 11.141724,22.4775432 C11.0658567,22.4924716 10.9884466,22.5 10.9108139,22.5 L1.08895809,22.5 C0.487543144,22.5 0,22.0578707 0,21.5124766 C0,21.4420753 0.00830168147,21.3718758 0.0247634549,21.3030754 L4.93569133,0.778328943 C5.06321949,0.245337383 5.64305766,-0.0929855179 6.23079613,0.0226635941 C6.64783931,0.104725048 6.97359011,0.400132676 7.06408061,0.778328943 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.29806045,0.589643138 L8.98125636,16.1386935 C9.07690248,16.542475 8.79709686,16.9408289 8.35629301,17.0284418 C8.29939253,17.0397512 8.24133492,17.0454545 8.18311039,17.0454545 L0.816718568,17.0454545 C0.365657358,17.0454545 0,16.7105081 0,16.2973308 C0,16.2439964 0.0062262611,16.190815 0.0185725912,16.1386935 L3.7017685,0.589643138 C3.79741462,0.185861654 4.23229324,-0.0704435742 4.6730971,0.0171693895 C4.98587948,0.0793371577 5.23019258,0.303130815 5.29806045,0.589643138 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06408061,0.778328943 L11.9750085,21.3030754 C12.1025366,21.836067 11.7294625,22.3618941 11.141724,22.4775432 C11.0658567,22.4924716 10.9884466,22.5 10.9108139,22.5 L1.08895809,22.5 C0.487543144,22.5 0,22.0578707 0,21.5124766 C0,21.4420753 0.00830168147,21.3718758 0.0247634549,21.3030754 L4.93569133,0.778328943 C5.06321949,0.245337383 5.64305766,-0.0929855179 6.23079613,0.0226635941 C6.64783931,0.104725048 6.97359011,0.400132676 7.06408061,0.778328943 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12071369,0.448128785 L6.98542162,12.265407 C7.05981304,12.572281 6.84218644,12.8750299 6.499339,12.9416158 C6.45508308,12.9502109 6.40992716,12.9545455 6.36464141,12.9545455 L0.635225553,12.9545455 C0.284400167,12.9545455 0,12.6999862 0,12.3859714 C0,12.3454373 0.00484264752,12.3050194 0.0144453487,12.265407 L2.87915328,0.448128785 C2.9535447,0.141254857 3.29178363,-0.0535371164 3.63463107,0.013048736 C3.87790626,0.0602962399 4.06792756,0.23037942 4.12071369,0.448128785 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88673384,0.707571766 L9.97917374,19.3664322 C10.0854472,19.85097 9.77455206,20.3289946 9.28477001,20.4341302 C9.22154725,20.4477015 9.1570388,20.4545455 9.09234488,20.4545455 L0.907465076,20.4545455 C0.406285953,20.4545455 0,20.0526098 0,19.5567969 C0,19.4927957 0.00691806789,19.428978 0.0206362125,19.3664322 L4.11307611,0.707571766 C4.21934958,0.223033984 4.70254805,-0.084532289 5.19233011,0.0206032674 C5.53986609,0.0952045893 5.81132509,0.363756978 5.88673384,0.707571766 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83010076,0.990600473 L14.9687606,27.113005 C15.1281708,27.7913579 14.6618281,28.4605925 13.927155,28.6077823 C13.8323209,28.626782 13.7355582,28.6363636 13.6385173,28.6363636 L1.36119761,28.6363636 C0.60942893,28.6363636 0,28.0736537 0,27.3795157 C0,27.289914 0.0103771018,27.2005692 0.0309543187,27.113005 L6.16961417,0.990600473 C6.32902437,0.312247578 7.05382207,-0.118345205 7.78849516,0.0288445744 C8.30979913,0.133286425 8.71698763,0.50925977 8.83010076,0.990600473 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.29806045,0.589643138 L8.98125636,16.1386935 C9.07690248,16.542475 8.79709686,16.9408289 8.35629301,17.0284418 C8.29939253,17.0397512 8.24133492,17.0454545 8.18311039,17.0454545 L0.816718568,17.0454545 C0.365657358,17.0454545 0,16.7105081 0,16.2973308 C0,16.2439964 0.0062262611,16.190815 0.0185725912,16.1386935 L3.7017685,0.589643138 C3.79741462,0.185861654 4.23229324,-0.0704435742 4.6730971,0.0171693895 C4.98587948,0.0793371577 5.23019258,0.303130815 5.29806045,0.589643138 Z",
    id: "path-15"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GDPR-Personopplysning-forside-Copy",
    transform: "translate(-564.000000, -694.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(558.000000, 694.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gjenstander/natur/-gress",
    transform: "translate(0.000000, 51.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,24 L301,24 C289.234261,22.8892455 267.900928,21.4155613 237,19.5789474 C190.648608,16.8240265 168.566375,12 121,12 C89.2890831,12 48.9557498,16 0,24 Z",
    id: "Path-34",
    fill: "#CDE7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,24 L464,24 C439.333333,12.9905482 397,5.36862004 337,1.1342155 C277,-3.10018904 218.333333,4.52173913 161,24 Z",
    id: "Path-33",
    fill: "#6AB889"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gjenstander/natur/-tre",
    transform: "translate(428.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#59514B",
    fillRule: "nonzero",
    points: "6.52173913 28.6666667 8.47826087 28.6666667 9.13043478 43 5.86956522 43"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Triangle",
    fill: "#117938",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "V\\u2699\\uFE0F/STYLING/farge/Oransje/+20",
    mask: "url(#mask-2)",
    fill: "#D87F0A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28.695652, -14.984848)",
    id: "Fill-50"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 73 73 73 73 0 0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gjenstander/natur/-tre",
    transform: "translate(402.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#59514B",
    fillRule: "nonzero",
    points: "5.2173913 22 6.7826087 22 7.30434783 33 4.69565217 33"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Triangle",
    fill: "#117938",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "V\\u2699\\uFE0F/STYLING/farge/-Fokus-oransje/+20",
    mask: "url(#mask-4)",
    fill: "#D8A25C",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.956522, -11.500000)",
    id: "Fill-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 56 58 56 58 0 0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gjenstander/natur/-tre",
    transform: "translate(214.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#59514B",
    fillRule: "nonzero",
    points: "3.91304348 16.6666667 5.08695652 16.6666667 5.47826087 25 3.52173913 25"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Triangle",
    fill: "#117938",
    fillRule: "nonzero",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "V\\u2699\\uFE0F/STYLING/farge/-Fokus-oransje/+20",
    mask: "url(#mask-6)",
    fill: "#D8A25C",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.217391, -8.712121)",
    id: "Fill-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 42 44 42 44 0 0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gjenstander/natur/-tre",
    transform: "translate(220.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#59514B",
    fillRule: "nonzero",
    points: "5.2173913 22 6.7826087 22 7.30434783 33 4.69565217 33"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Triangle",
    fill: "#117938",
    fillRule: "nonzero",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "V\\u2699\\uFE0F/STYLING/farge/Gr\\xF8nn/-+20",
    mask: "url(#mask-8)",
    fill: "#117938",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.956522, -11.500000)",
    id: "Fill-78"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 56 58 56 58 0 0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gjenstander/natur/-tre",
    transform: "translate(175.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#59514B",
    fillRule: "nonzero",
    points: "3.04347826 12.6666667 3.95652174 12.6666667 4.26086957 19 2.73913043 19"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Triangle",
    fill: "#117938",
    fillRule: "nonzero",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "V\\u2699\\uFE0F/STYLING/farge/Gr\\xF8nn/-+20",
    mask: "url(#mask-10)",
    fill: "#117938",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.391304, -6.621212)",
    id: "Fill-78"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 32 34 32 34 0 0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gjenstander/natur/-tre",
    transform: "translate(348.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#59514B",
    fillRule: "nonzero",
    points: "4.34782609 20 5.65217391 20 6.08695652 30 3.91304348 30"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Triangle",
    fill: "#117938",
    fillRule: "nonzero",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "V\\u2699\\uFE0F/STYLING/farge/Gr\\xF8nn/-+20",
    mask: "url(#mask-12)",
    fill: "#117938",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.130435, -10.454545)",
    id: "Fill-78"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 51 49 51 49 0 0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gjenstander/natur/-tre",
    transform: "translate(267.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#59514B",
    fillRule: "nonzero",
    points: "6.52173913 28 8.47826087 28 9.13043478 42 5.86956522 42"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Triangle",
    fill: "#117938",
    fillRule: "nonzero",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "V\\u2699\\uFE0F/STYLING/farge/Oransje/+20",
    mask: "url(#mask-14)",
    fill: "#D87F0A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28.695652, -14.636364)",
    id: "Fill-50"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 71 73 71 73 0 0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gjenstander/natur/-tre",
    transform: "translate(191.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#59514B",
    fillRule: "nonzero",
    points: "3.91304348 16.6666667 5.08695652 16.6666667 5.47826087 25 3.52173913 25"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Triangle",
    fill: "#117938",
    fillRule: "nonzero",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("g", {
    id: "V\\u2699\\uFE0F/STYLING/farge/Oransje/+20",
    mask: "url(#mask-16)",
    fill: "#D87F0A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.217391, -8.712121)",
    id: "Fill-50"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 42 44 42 44 0 0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gjenstander/natur/-sky-1",
    transform: "translate(310.000000, 0.000000)",
    fill: "#C2EAF7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.163843,-3.64153152e-14 C105.314311,-3.64153152e-14 107.869565,2.56636974 107.869565,5.7341319 C107.869565,5.8914064 107.863267,6.0471985 107.850909,6.2012677 C108.229166,6.14594523 108.616681,6.11726496 109.01087,6.11726496 C113.423644,6.11726496 117,9.71142815 117,14.1461752 C117,18.5809223 113.423644,22.1750855 109.01087,22.1750855 C107.458367,22.1750855 106.009394,21.7302094 104.783267,20.9603683 C104.442425,23.8005704 102.036681,26 99.1187573,26 C96.2799847,26 93.9251684,23.9161394 93.4863842,21.1864372 C93.1093584,21.3314374 92.6996913,21.4104273 92.2717391,21.4104273 C90.3813983,21.4104273 88.8478261,19.8692191 88.8478261,17.9694658 C88.8478261,17.2536737 89.0655387,16.5887822 89.4380173,16.0380515 C85.2838371,15.755118 82,12.27696 82,8.02891025 C82,3.59510866 85.5772964,5.32907052e-15 89.9891304,5.32907052e-15 C92.8607755,5.32907052e-15 95.3788557,1.52312383 96.7870217,3.80925613 C97.5733057,1.58865 99.6838532,-3.64153152e-14 102.163843,-3.64153152e-14 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("g", {
    id: "gjenstander/natur/-sky-2",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9992244,-2.84217094e-14 C28.4184198,-2.84217094e-14 32,3.5947478 32,8.02863334 C32,11.124666 30.2549339,13.8110841 27.6980225,15.1512359 C28.4833244,16.1318971 28.952381,17.378346 28.952381,18.7352941 C28.952381,21.9025961 26.3941687,24.4705882 23.2372614,24.4705882 C21.5344262,24.4705882 20.005481,23.7226353 18.9587017,22.5361838 C16.9523547,24.6731323 14.1496021,26 11.0484059,26 C4.94747016,26 2.84217094e-14,20.8647448 2.84217094e-14,14.5302287 C2.84217094e-14,8.19571256 4.94747016,3.05882353 11.0484059,3.05882353 C13.1239562,3.05882353 15.0658253,3.65335359 16.7247517,4.68730889 C17.9868889,1.92123801 20.7696365,-2.84217094e-14 23.9992244,-2.84217094e-14 Z",
    id: "Combined-Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNatur);
export default __webpack_public_path__ + "static/media/Natur.17d94927c832fe7724cfd8788f88c8dd.svg";
export { ForwardRef as ReactComponent };